import React, { useState } from 'react';

function TestHistory({ testHistory, onSelectRun }) {
  const [filterEnvironment, setFilterEnvironment] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return '✅';
      case 'failed':
        return '❌';
      case 'running':
        return '⏳';
      default:
        return '❓';
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'completed':
        return 'status-completed';
      case 'failed':
        return 'status-failed';
      case 'running':
        return 'status-running';
      default:
        return 'status-default';
    }
  };

  // Filter test runs
  const filteredHistory = testHistory.filter(run => {
    if (filterEnvironment !== 'all' && run.environment !== filterEnvironment) {
      return false;
    }
    if (filterStatus !== 'all' && run.status !== filterStatus) {
      return false;
    }
    return true;
  });

  return (
    <div className="test-history">
      <div className="history-header">
        <h2>Test History</h2>
        <div className="history-filters">
          <select
            value={filterEnvironment}
            onChange={(e) => setFilterEnvironment(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Environments</option>
            <option value="development">Development</option>
            <option value="production">Production</option>
          </select>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Status</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
            <option value="running">Running</option>
          </select>
        </div>
      </div>

      <div className="history-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Environment</th>
              <th>Status</th>
              <th>Tests</th>
              <th>Success Rate</th>
              <th>Started</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">No test runs found</td>
              </tr>
            ) : (
              filteredHistory.map((run) => (
                <tr key={run.id}>
                  <td>#{run.id}</td>
                  <td>
                    <span className={`env-badge ${run.environment}`}>
                      {run.environment}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusClass(run.status)}`}>
                      {getStatusIcon(run.status)} {run.status}
                    </span>
                  </td>
                  <td>
                    <div className="test-counts">
                      <span className="passed">{run.passed_tests}</span>
                      <span className="separator"> / </span>
                      <span className="total">{run.total_tests}</span>
                    </div>
                  </td>
                  <td>
                    <div className={`success-rate ${run.success_rate === 100 ? 'perfect' : run.success_rate >= 50 ? 'partial' : 'low'}`}>
                      {run.success_rate?.toFixed(1)}%
                    </div>
                  </td>
                  <td className="date-cell">{formatDate(run.started_at)}</td>
                  <td>{run.user_username}</td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => onSelectRun(run)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TestHistory;